export default {"src":"/_next/static/media/board_games.1e5945b8.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};